import Images from '../lib/images';

const getHostname = () => {
  const defaultHost = 'www.duke-energy.com';
  if (typeof window === 'undefined') {
    return defaultHost;
  }
  switch (window.location.hostname) {
    case 'sc10qa-micro.duke-energy.com':
      return 'sc10qa.duke-energy.com';
    case 'sc10test-micro.duke-energy.com':
      return 'sc10test.duke-enegy.com';
    default:
      return defaultHost;
  }
};

type JurisdictionKeyType = 'FL01' | 'IN01' | 'KY01' | 'OH01' | 'NC01' | 'NC02' | 'SC01' | 'SC02';
type JurisdictionDataType = typeof jurisdictionData;

const jurisdictionData = {
  FL01: {
    img: Images.jurisdiction.floridaReversed,
    name: 'Florida',
    title: 'Check out the Home Energy Improvement Program',
    description:
      'The Find it Duke referral service is not available to customers residing in Florida, but the Home Energy Improvement program might be just what you need.',
    buttonText: 'LEARN MORE',
    buttonLink: `https://${getHostname()}/home/products/home-energy-improvement`,
  },
  IN01: {
    img: Images.jurisdiction.indianaReversed,
    name: 'Indiana',
  },
  KY01: {
    img: Images.jurisdiction.kentuckyReversed,
    name: 'Kentucky',
  },
  OH01: {
    img: Images.jurisdiction.ohioReversed,
    name: 'Ohio',
  },
  NC01: {
    img: Images.jurisdiction.northCarolinaReversed,
    name: 'North Carolina',
  },
  NC02: {
    img: Images.jurisdiction.northCarolinaReversed,
    name: 'North Carolina',
  },
  SC01: {
    img: Images.jurisdiction.southCarolinaReversed,
    name: 'South Carolina',
  },
  SC02: {
    img: Images.jurisdiction.southCarolinaReversed,
    name: 'South Carolina',
  },
};

const getJur = ({
  jurisdiction,
  jurisdictionData,
}: {
  jurisdiction: JurisdictionKeyType;
  jurisdictionData: JurisdictionDataType;
}) => {
  if (jurisdiction === 'FL01') {
    return jurisdictionData[jurisdiction];
  } else {
    return {
      img: jurisdictionData[jurisdiction].img,
      name: jurisdictionData[jurisdiction].name,
      title: 'We didn’t find any special offers for your area.',
      description: jurisdictionData[jurisdiction].name + " doesn't have any offers at this time.",
      buttonLink: '/find-a-contractor',
      buttonText: 'FIND A CONTRACTOR',
    };
  }
};

const NoOffers = ({
  jurisdiction,
  returnBackToStates,
}: {
  jurisdiction: keyof typeof jurisdictionData;
  returnBackToStates: (e: any) => void;
}) => {
  const jur = getJur({ jurisdiction, jurisdictionData });
  return (
    <div className="bg-gray-lighter w-full py-48 px-24 relative">
      <button
        className="sm:absolute ml-24 mb-24 flex items-center -mt-12 cursor-pointer"
        onClick={returnBackToStates}
      >
        <img src={Images.arrow} className="h-12 w-auto mr-4" alt="" />
        <p className="text-md font-bold text-teal-darker">Back to State</p>
      </button>
      <div className="flex flex-col items-center container-md">
        <div className="icon-76 rounded-full border-2 border-teal-darker">
          <div className="">
            <img src={jur.img} className="self-center" alt="" />
          </div>
        </div>
        <h3 className="text-2xl text-gray-darker mt-12 text-center">
          {jur.title || 'We didn’t find any special offers for your area.'}
        </h3>
        <p className="text-lg text-gray-dark text-center mt-12">
          {jur.description || jur.name + " doesn't have any offers at this time."}
        </p>
        <div className="flex justify-center space-x-12 mt-32">
          <a
            href={jur.buttonLink || '/find-a-contractor'}
            className="btn btn-primary btn-md"
            type="button"
            style={{ width: 'auto' }}
          >
            {jur.buttonText || 'FIND A CONTRACTOR'}
          </a>
        </div>
      </div>
    </div>
  );
};

export default NoOffers;
